var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndrawUnexpectedFriendsTg6K(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 877,
    height: 732.809,
    viewBox: "0 0 877 732.809",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pokeball",
    fill: "#de6834"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#f2f2f2",
    width: 98,
    height: 98,
    transform: "translate(229.066 216.948) rotate(30)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#de6834",
    cx: 72,
    cy: 72,
    r: 72,
    transform: "translate(677.591 78.798)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M867.067,134.553c8.974,22,31.813,33.5,31.813,33.5s8.288-24.186-.686-46.19-31.813-33.5-31.813-33.5S858.093,112.548,867.067,134.553Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de6834",
    d: "M875.512,128.541c18.934,14.361,24.126,39.395,24.126,39.395s-25.507,1.75-44.441-12.611-24.126-39.395-24.126-39.395S856.577,114.18,875.512,128.541Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M902.482,121.975c-8.794,22.077-.307,46.194-.307,46.194s22.744-11.678,31.537-33.755.307-46.194.307-46.194S911.275,99.9,902.482,121.975Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de6834",
    d: "M912.735,123.5c3.683,23.477-9.937,45.114-9.937,45.114s-19.591-16.427-23.274-39.9S889.461,83.6,889.461,83.6,909.052,100.022,912.735,123.5Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#f2f2f2",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(708.631 106.226)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3f3d56",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(718.089 120.908)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M1016.5,678.477a22,22,0,1,1,22-22A22,22,0,0,1,1016.5,678.477Zm0-42a20,20,0,1,0,20,20,20,20,0,0,0-20-20Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M428.5,451.477a22,22,0,1,1,22-22,22,22,0,0,1-22,22Zm0-42a20,20,0,1,0,20,20,20,20,0,0,0-20-20Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M957.038,245.114,840.061,375.674a57.987,57.987,0,1,1-77.2,86.161L599.921,643.7a267.1,267.1,0,0,0,164.3,56.2c148.165,0,268.276-120.111,268.276-268.276a267.37,267.37,0,0,0-75.462-186.51Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#f2f2f2",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(610 305.882)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#de6834",
    cx: 72,
    cy: 72,
    r: 72,
    transform: "translate(107.634 508.425)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M272.807,578.946c14.355,18.938,39.388,24.137,39.388,24.137s1.757-25.506-12.6-44.444S260.209,534.5,260.209,534.5,258.451,560.008,272.807,578.946Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de6834",
    d: "M279.411,570.956c22,8.981,33.486,31.823,33.486,31.823s-24.188,8.281-46.19-.7-33.486-31.823-33.486-31.823S257.409,561.975,279.411,570.956Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M303.769,557.644c-2.79,23.6,11.64,44.7,11.64,44.7s18.954-17.158,21.744-40.758-11.64-44.7-11.64-44.7S306.559,534.044,303.769,557.644Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de6834",
    d: "M314.068,556.468c9.624,21.728,2.058,46.149,2.058,46.149s-23.17-10.807-32.794-32.535-2.058-46.149-2.058-46.149S304.444,534.74,314.068,556.468Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#f2f2f2",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(114.853 547.134)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3f3d56",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(125.817 583.875)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#de6834",
    cx: 72,
    cy: 72,
    r: 72,
    transform: "translate(391 474.882)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M593.064,525.988c6.206,22.94,27.461,37.147,27.461,37.147s11.194-22.985,4.989-45.925-27.461-37.147-27.461-37.147S586.858,503.048,593.064,525.988Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de6834",
    d: "M602.182,521.058c17.028,16.576,19.108,42.058,19.108,42.058s-25.528-1.394-42.557-17.97-19.108-42.058-19.108-42.058S585.154,504.482,602.182,521.058Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M629.754,517.852c-11.437,20.831-5.975,45.807-5.975,45.807s24.005-8.8,35.442-29.629,5.975-45.807,5.975-45.807S641.191,497.021,629.754,517.852Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#de6834",
    d: "M639.743,520.624c.773,23.752-15.4,43.553-15.4,43.553s-17.426-18.707-18.2-42.459,15.4-43.553,15.4-43.553S638.97,496.872,639.743,520.624Z",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#f2f2f2",
    cx: 37,
    cy: 37,
    r: 37,
    transform: "translate(423 501.882)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3f3d56",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(448 505.882)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M0,0H375V2H0Z",
    transform: "translate(287 616.882)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#de6834",
    cx: 20.5,
    cy: 16,
    rx: 20.5,
    ry: 16,
    transform: "translate(793 168.882)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M408.639,606.509l32.788-26.258",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M410.737,626.744Q425.6,614.733,441.511,604.1",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M432.607,624.613a113.664,113.664,0,0,0,31.25-21.966",
    transform: "translate(-161.5 -83.595)"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#3f3d56",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(171 612.882)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#f2f2f2",
    cx: 99,
    cy: 11.928,
    rx: 99,
    ry: 11.928,
    transform: "translate(0 708.954)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3f3d56",
    d: "M793.5,701.477a22,22,0,1,1,22-22,22,22,0,0,1-22,22Zm0-42a20,20,0,1,0,20,20A20,20,0,0,0,793.5,659.477Z",
    transform: "translate(-161.5 -83.595)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawUnexpectedFriendsTg6K);
export default __webpack_public_path__ + "static/media/undraw_unexpected_friends_tg6k.48ef6b01.svg";
export { ForwardRef as ReactComponent };